export enum MixpanelPromptTypeEnum {
    Recommendation = 'action prompt',
    Close = 'text prompt'
}
